<div data-id="search-results-loading-skeleton" class="bd-loading-skeleton">
  <div class="bd-header">
    <p-skeleton class="block" width="9rem" />
  </div>
  @for (n of [].constructor(20); track $index) {
    <div class="bd-item flex justify-between">
      <div class="flex">
        <p-skeleton width="24px" height="24px" class="mr-4 self-center" />
        <div class="flex flex-col gap-2">
          <p-skeleton width="9rem" />
          <p-skeleton width="24rem" />
        </div>
      </div>
      <p-skeleton width="24px" height="24px" class="ml-4 mr-6 self-center" />
    </div>
  }
</div>
